import { useMemo, type MutableRefObject } from 'react';

import type { ReferenceType } from '@floating-ui/react';

type FloatingPortalRootConfig = {
    getPopupContainer?: (reference: HTMLElement) => HTMLElement;
    refs: {
        reference: MutableRefObject<ReferenceType | null>;
    };
};

export const useFloatingPortalRoot = ({ getPopupContainer, refs }: FloatingPortalRootConfig) => {
    const referenceEl = refs.reference.current;
    return useMemo(() => {
        if (typeof window === 'undefined') return null;
        const isHTMLElement = (el: unknown): el is HTMLElement =>
            !!el && typeof el === 'object' && 'nodeType' in el && el.nodeType === Node.ELEMENT_NODE;
        if (typeof getPopupContainer === 'function' && isHTMLElement(referenceEl)) {
            return getPopupContainer(referenceEl) ?? window.document.body;
        }
        return window.document.body;
    }, [getPopupContainer, referenceEl]);
};
